import { $axios } from "./BaseURL";
import notification from "@/core/plugins/notification";
import { ElNotification } from "element-plus";
import Storage from "./Storage";

const axiosInstances = [$axios];

function setHeaderFormData() {
  axiosInstances.forEach((axios) => {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    axios.defaults.headers.post["Accept"] = "application/json";
  });
}

function setHeaderFormDataAuth() {
  axiosInstances.forEach((axios) => {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    axios.defaults.headers.post["Accept"] = "application/json";
    if (Storage.getToken()) {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${Storage.getToken()}`;
    }
  });
}

axiosInstances.forEach((axios) => {
  axios.interceptors.response.use(
    function (response) {
      if (
        response.data.status != "success" &&
        response.data.msg &&
        response.data.msg != "File uploaded successfully"
      ) {
        // notification.message(response.data.status, response.data.msg);
      }
      return response;
    },
    function (error) {
      ElNotification({
        title: "Error",
        message: error.response.data.error,
        type: "error",
      });
      if (process.env.NODE_ENV === "development") {
        console.log(error);
      }
      if (Storage.getToken()) {
        if (error.status == 401) {
          Storage.clearToken();
          window.location.reload();
        }
      }
      if (error.response.data.msg) {
        // notification.message("error", error.response.data.msg);
      }
      return error.response;
      // return Promise.reject(error);
    }
  );
});

const get = (path: any, params: any = undefined) => {
  setHeaderFormData();
  return $axios.get(path, { params });
};

const post = (path: any, data: any = undefined, headers: any = {}) => {
  setHeaderFormData();
  return $axios.post(path, data, {
    headers: {
      ...headers,
    },
  });
};

const postUpload = (path: any, data: any) => {
  setHeaderFormDataAuth();
  return $axios.post(path, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getAuth = (path: any, params: any = undefined) => {
  setHeaderFormDataAuth();
  return $axios.get(path, { params });
};

const postAuth = (path: any, data: any = undefined) => {
  setHeaderFormDataAuth();
  return $axios.post(path, data);
};

export { get, post, postUpload, getAuth, postAuth };
